import React from 'react'
import { Card, CardBody, Row, Col } from 'reactstrap'
import { Tasks as MgtTasks } from '@microsoft/mgt-react'
import { Link } from 'react-router-dom'
import moment from 'moment'

export default function () {
  return (
    <Card>
      <CardBody>
        <Row className="d-flex justify-content-between">
          <Col>
            <h4 className="card-title mb-4">Tarefas</h4>
          </Col>
          <Col className="d-flex justify-content-end">
            {/* <a
              target="_blank"
              rel="noreferrer"
              href="https://outlook.office365.com/calendar/view/workweek"
            >
              Ver tudo
            </a> */}
            <Link to="/agenda">
              Ver tudo
            </Link>
          </Col>
        </Row>
        <MgtTasks readOnly />
      </CardBody>
    </Card>
  )
}
